var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.thumbnail),expression:"thumbnail"}],staticClass:"image max-h-thumb-s",attrs:{"alt":_vm.product.name}})}
var staticRenderFns = []

export { render, staticRenderFns }